<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="ch00_part01"><a id="page_1"></a>PART I<br/><em>Before the Written Record</em></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_part01.vue?3454483a